import { CandidatoDetail, SaveCandidatoInput } from './../types'
import { apiSauceInstance } from '../../../services/api'

import { EdgesPage } from '@elentari/core/types'
import { makeRepository } from '@elentari/core/utils/makeRepository'
import { paginationParams } from '../../../utils/paginationQueryParams'
import { ParsedQs } from 'qs'

const mapQueryParams = (params: ParsedQs): ParsedQs => {
  const { sort, ...rest } = params
  return { ...params, ...paginationParams(rest) }
}

export const repository = makeRepository<
  EdgesPage<CandidatoDetail>,
  SaveCandidatoInput,
  CandidatoDetail,
  string
>(
  {
    resource: 'candidato',
    mapQueryParams
  },
  apiSauceInstance
)

export const checaCpf = async (cpf: string) => {
  const response = await apiSauceInstance.get<any>(
    `/lista-bloqueios/cpf/${cpf}`
  )

  const { data: info, ok, status } = response

  if (info && ok) {
    return {
      info,
      ok,
      status
    }
  }
  return null
}

export const fetchListaTriagem = async (filterString: string) => {
  const response = await apiSauceInstance.get<{ id: string }[]>(
    `/candidato/lista-triagem?${filterString}`
  )

  const { data: info, ok, status } = response

  if (info && ok) {
    return {
      info,
      ok,
      status
    }
  }
  return null
}

export const updateNotaClassificacao = async (candidatoId: string, notaClassificacao: number) => {
  const response = await apiSauceInstance.post<CandidatoDetail>(
    `candidato/alterar-nota/${candidatoId}`, { notaClassificacao }
  )

  const { data: info, ok, status } = response

  if (info && ok) {
    return {
      info,
      ok,
      status
    }
  }
  return null
}

export const reprovarCandidatoAgendamento = async (candidatoId: string) => {
  const response = await apiSauceInstance.get<CandidatoDetail>(
    `candidato/reprovar-candidato-agendamento/${candidatoId}`
  )

  const { data: info, ok, status } = response

  if (info && ok) {
    return {
      info,
      ok,
      status
    }
  }
  return null
}